import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogType } from '@type/dialog-type';

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.scss'],
})
export class MessageDialogComponent {
  public title: string;
  public text: string;

  public message: string = '';

  public static cssClass: DialogType = 'black-fullscreen-dialog';

  constructor(
    public dialogRef: MatDialogRef<MessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
  ) {
    this.title = this.data.title;
    this.text = this.data.text;
  }

  public cancel() {
    this.dialogRef.close({
      message: this.message,
      decision: 'cancel',
    });
  }

  public send() {
    this.dialogRef.close({
      message: this.message,
      decision: 'send',
    });
  }
}
